import { ReplaceStandupsArticle } from '@/components/replace-standups/replace-standups-article'
import { Container } from '@/components/container'
import { Footer } from '@/components/footer'
import { Navbar } from '@/components/navbar'
import { Head } from '@inertiajs/react'

const TITLE = 'Replace Standups with GitHub Activity Digests'
const DESCRIPTION =
  'Replace a standup with GitHub activity digests. Pick the repos, then send daily or weekly commit summaries to Slack and email.'

type Faq = {
  question: string
  answer: string
}

type Props = {
  headline: string
  faqs: Faq[]
}

export default function ReplaceStandupsShow({ headline, faqs }: Props) {
  return (
    <>
      <Head title={TITLE}>
        <meta head-key="description" name="description" content={DESCRIPTION} />
      </Head>
      <div className="flex min-h-screen flex-col">
        <main className="flex-1 overflow-hidden">
          <Container>
            <Navbar />
          </Container>
          <div className="from-background via-feature-subtle/50 to-muted/20 min-h-100vh bg-gradient-to-b">
            <Container className="py-16 md:py-24">
              <ReplaceStandupsArticle headline={headline} faqs={faqs} />
            </Container>
          </div>
        </main>
        <Footer />
      </div>
    </>
  )
}
